// extracted by mini-css-extract-plugin
export var avatarContainer = "_cw-0";
export var avatarTypingWave = "_cw-i";
export var gray = "_cw-f";
export var green = "_cw-c";
export var icon = "_cw-9";
export var image = "_cw-1";
export var lg = "_cw-6";
export var md = "_cw-5";
export var presenceDot = "_cw-b";
export var red = "_cw-d";
export var sm = "_cw-4";
export var status = "_cw-a";
export var typingDot = "_cw-h";
export var typingPill = "_cw-g";
export var xl = "_cw-7";
export var xs = "_cw-3";
export var xxl = "_cw-8";
export var xxs = "_cw-2";
export var yellow = "_cw-e";